import { DoqFaceSvgProps } from '../types';

const Alarm = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 144 144"
    fill="none"
    className={className}
    role="presentation"
  >
    <defs>
      <clipPath id="clip0_1393_56301">
        <rect width="144" height="144" fill="white" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0_1393_56301)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-alarm">
        <circle cx="72" cy="72" r="72" fill="white" />
        <path d="M 108,135 A 72,72 0 0,1 36,135 L 72,72 Z" fill="black" />
      </mask>
      <circle
        cx="72"
        cy="72"
        r="72"
        fill="#FCBF4C"
        mask="url(#bottom-mask-alarm)"
      />

      <mask
        id="mask0_1393_56301"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="144"
        height="144"
      >
        <circle cx="72" cy="72" r="72" fill="#FCB226" />
      </mask>
      <g mask="url(#mask0_1393_56301)">
        <rect x="36" y="54" width="72" height="90" fill="white" />
      </g>
      <path
        d="M63.8998 82.8001C65.888 82.8001 67.4998 81.1883 67.4998 79.2001C67.4998 77.2119 65.888 75.6001 63.8998 75.6001C61.9116 75.6001 60.2998 77.2119 60.2998 79.2001C60.2998 81.1883 61.9116 82.8001 63.8998 82.8001Z"
        fill="#2974C4"
      />
      <path
        d="M80.0998 82.8001C82.088 82.8001 83.6998 81.1883 83.6998 79.2001C83.6998 77.2119 82.088 75.6001 80.0998 75.6001C78.1116 75.6001 76.4998 77.2119 76.4998 79.2001C76.4998 81.1883 78.1116 82.8001 80.0998 82.8001Z"
        fill="#2974C4"
      />
      <path
        d="M80.0992 50.3999V50.4007C80.329 50.4113 80.5407 50.5318 80.667 50.7257L82.7992 53.9999H61.1992L63.3315 50.7257C63.4578 50.5318 63.6694 50.4113 63.8992 50.4007V50.3999H80.0992Z"
        fill="#141414"
      />
      <path
        d="M71.5578 25.2C72.0548 25.2047 72.454 25.6114 72.4493 26.1084L72.3815 33.3084C72.3768 33.8055 71.9701 34.2046 71.473 34.1999C70.976 34.1952 70.5769 33.7885 70.5816 33.2915L70.6494 26.0915C70.6541 25.5944 71.0608 25.1953 71.5578 25.2Z"
        fill="#CB3434"
      />
      <path
        d="M86.4028 33.4186C86.8344 33.172 87.3842 33.3219 87.6308 33.7535C87.8774 34.185 87.7274 34.7348 87.2959 34.9814L80.9959 38.5814C80.5643 38.828 80.0145 38.6781 79.7679 38.2465C79.5213 37.815 79.6713 37.2652 80.1028 37.0186L86.4028 33.4186Z"
        fill="#CB3434"
      />
      <path
        d="M63.8994 42.9931C63.8994 39.1309 67.0303 36 70.8925 36H73.1063C76.9685 36 80.0994 39.1309 80.0994 42.9931V50.4H63.8994V42.9931Z"
        fill="#CB3434"
      />
      <path
        d="M81.4494 47.7C81.4494 47.2029 81.8524 46.8 82.3494 46.8H90.4494C90.9465 46.8 91.3494 47.2029 91.3494 47.7C91.3494 48.197 90.9465 48.6 90.4494 48.6H82.3494C81.8524 48.6 81.4494 48.197 81.4494 47.7Z"
        fill="#CB3434"
      />
      <path
        d="M53.5494 46.8C53.0524 46.8 52.6494 47.2029 52.6494 47.7C52.6494 48.197 53.0524 48.6 53.5494 48.6H61.6494C62.1465 48.6 62.5494 48.197 62.5494 47.7C62.5494 47.2029 62.1465 46.8 61.6494 46.8H53.5494Z"
        fill="#CB3434"
      />
      <path
        d="M56.3679 33.7535C56.6145 33.3219 57.1643 33.172 57.5959 33.4186L63.8959 37.0186C64.3274 37.2652 64.4774 37.815 64.2308 38.2465C63.9842 38.6781 63.4344 38.828 63.0028 38.5814L56.7028 34.9814C56.2713 34.7348 56.1213 34.185 56.3679 33.7535Z"
        fill="#CB3434"
      />
      <path
        d="M73.3496 37.8C73.3496 37.8 75.8982 38.8722 77.0006 41.092C78.1031 43.3118 77.7739 46.8 77.7739 46.8"
        stroke="white"
        strokeWidth="0.9"
        strokeLinecap="round"
      />
      <g opacity="0.5">
        <path
          d="M43.1992 109.35C43.1992 109.101 43.4007 108.9 43.6492 108.9H100.349C100.598 108.9 100.799 109.101 100.799 109.35V110.25C100.799 110.499 100.598 110.7 100.349 110.7H43.6492C43.4007 110.7 43.1992 110.499 43.1992 110.25V109.35Z"
          fill="#2974C4"
        />
        <path
          d="M43.1992 124.65C43.1992 124.401 43.4007 124.2 43.6492 124.2H100.349C100.598 124.2 100.799 124.401 100.799 124.65V125.55C100.799 125.799 100.598 126 100.349 126H43.6492C43.4007 126 43.1992 125.799 43.1992 125.55V124.65Z"
          fill="#2974C4"
        />
        <path
          d="M43.6492 116.1C43.4007 116.1 43.1992 116.301 43.1992 116.55V117.45C43.1992 117.699 43.4007 117.9 43.6492 117.9H100.349C100.598 117.9 100.799 117.699 100.799 117.45V116.55C100.799 116.301 100.598 116.1 100.349 116.1H43.6492Z"
          fill="#2974C4"
        />
        <path
          d="M43.1992 131.85C43.1992 131.601 43.4007 131.4 43.6492 131.4H100.349C100.598 131.4 100.799 131.601 100.799 131.85V132.75C100.799 132.999 100.598 133.2 100.349 133.2H43.6492C43.4007 133.2 43.1992 132.999 43.1992 132.75V131.85Z"
          fill="#2974C4"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.8328 93.5974C72.3671 93.563 72 93.1743 72 92.6999C72 92.2028 72.4029 91.7999 72.9 91.7999H79.425C80.2948 91.7999 81 91.0947 81 90.2249C81 90.1483 80.9945 90.073 80.984 89.9994L81 89.9994C81.0002 89.5026 81.4031 89.0999 81.9 89.0999C82.3971 89.0999 82.8 89.5028 82.8 89.9999C82.8 90.0262 82.7989 90.0522 82.7967 90.0779L82.7926 89.9996C82.7975 90.074 82.8 90.1491 82.8 90.2249C82.8 92.0888 81.289 93.5999 79.425 93.5999H72.9L72.8328 93.5974Z"
        fill="#2974C4"
      />
    </g>
  </svg>
);

export { Alarm };
